import React from 'react';

import { Messages } from '../../../codegen/Localize';
import { IPublishedConnectionInfo } from '../../../ts/models/IPublishedConnectionInfo';
import { DetailsTooltipStyles } from '../CardView/DetailsTooltipStyles';
import { MarkupField } from '../Components/MarkupField';
import { Name } from './Elements/Name';
import { RelatedEntity } from './Elements/RelatedEntity';
import { Tags } from './Elements/Tags';
import { Timestamp } from './Elements/Timestamp';
import { Tooltip } from './Elements/Tooltip';
import { User } from './Elements/User';
import { ContentTooltipProps, getProjectLink, TooltipDescriptionTestId } from './TooltipHelper';

export function PublishedConnectionTooltip(props: ContentTooltipProps): JSX.Element {
  const { content, urls } = props;
  const publishedConnectionInfo = content as IPublishedConnectionInfo;
  const projectLink = getProjectLink(publishedConnectionInfo.project, urls);
  return (
    <Tooltip>
      <Name name={content.name} />
      <MarkupField
        markup={props.content.description}
        testId={TooltipDescriptionTestId}
        extraClasses={[DetailsTooltipStyles.MetadataSectionWithContentDescription]} />
      <Tags tags={props.content.tags} />
      {!props.inProjectSpace && <RelatedEntity label={Messages.project()} link={projectLink} />}
      <User user={props.content.owner} label={Messages.owner()} urls={urls} />
      <Timestamp label={Messages.modified()} value={props.content.updatedAt} />
    </Tooltip>
  );
}
